import { render, staticRenderFns } from "./dataAbnormal_log.vue?vue&type=template&id=20e999cf&"
import script from "./dataAbnormal_log.vue?vue&type=script&lang=js&"
export * from "./dataAbnormal_log.vue?vue&type=script&lang=js&"
import style0 from "./dataAbnormal_log.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports